
//Cache to store receivers
//Written by component, read in buildElementDependingOnRequiredInput and when user changes receiver in first row dropdown


var vendorsCache = [];


var lastVendorLookedUpCache;

var cacheAuthBearer;
var cacheTickCounter = 0;
var cacheTickScreenLink;

function setVendorsCacheFromComponent(cache) {
    vendorsCache = cache;
}

function getVendorsCache() {
    return vendorsCache;
}

var customColumnNames = [];

function setCustomColumnNamesFromComponent(columnNames) {
    customColumnNames = JSON.parse(columnNames);
}

function getColumnName(columnId) {

    try {
        var customColumnCount = customColumnNames.length;

        for (var i = 0; i < customColumnCount; i++) {
            if (customColumnNames[i].Id == columnId.id) {
                return customColumnNames[i].FriendlyName;
            }
        }
    } catch (e) {

    }

    if (columnId.id == "VisitorIdentificationVerified") {
        return "ID Check";
    }
    else if (columnId.id == "VisitorIsParcelDelivery") {
        return "Parcel";
    }
    else if (columnId.id == "VisitNotified") {
        return "Notified";
    }
    else if (columnId.id == "VisitorIsGuest") {
        return "Is guest";
    }
    else if (columnId.id == "VisitorVirusChecked") {
        return "Covid check";
    }
    else if (columnId.id == "VisitorHealthChecked") {
        return "Health check";
    }
    else if (columnId.id == "VisitorCalledAhead") {
        return "Called ahead";
    }
    else if (columnId.id == "VisitorTurnedAway") {
        return "Turned Away";
    }
    else if (columnId.id == "VisitNumber") {
        return "Visit number";
    }
    else if (columnId.id == "VisitorPhonenumber") {
        return "Phone";
    }
    else if (columnId.id == "VisitorIsTemporary") {
        return "Temporary";
    }
    else if (columnId.id == "ExpectedCheckinTimestamp") {
        return "Expected Arrival";
    }
    else if (columnId.id == "ExpectedCheckoutTimestamp") {
        return "Expected Departure";
    }
    else if (columnId.id == "ExpirationCheckinTimestamp") {
        return "Expiration Arrival";
    }
    else if (columnId.id == "ExpirationCheckoutTimestamp") {
        return "Expiration Departure";
    }
    else if (columnId.id == "RentalCheckin") {
        return "Rental";
    }
    else {
        return columnId.friendlyName;
    }


}


function initGuardScreenClipboard(arg) {
    $(document).ready(function () {
      
        $('#openGuardScreenClipboardButton').click(function () {

        
            // reset modal if it isn't visible
            if (!($('#guardScreenClipboardModal .modal.in').length)) {
                $('#guardScreenClipboardModal .modal-dialog').css({
                    top: 0,
                    left: 'calc(50vw)'
                });
            }
            $('#guardScreenClipboardModal').modal({
                backdrop: false,
                show: true
            });

            $('#guardScreenClipboardModal .modal-dialog').draggable({
                handle: ".modal-header"
            });
        });

    });

    return 1;
}